import { useEffect, useState, useCallback } from 'react';
import { hasValidCurrencyInPortal, isProcessorSupportedCurrency } from 'invoices-ui-lib/utils/validation';
import http from 'hub-http/clients/apiClient';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import PortalIdParser from 'PortalIdParser';
import { jsx as _jsx } from "react/jsx-runtime";
export const getCurrencyErrorMessage = (isCreate = false) => {
  if (isCreate) {
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "invoices.errors.createInvoiceCurrencyError_jsx",
      elements: {
        UILink
      },
      options: {
        href: `/settings/${PortalIdParser.get()}/account-defaults/multicurrency`,
        external: true
      }
    });
  }
  return /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: "invoices.errors.editInvoiceCurrencyError_jsx",
    elements: {
      UILink
    },
    options: {
      href: 'https://knowledge.hubspot.com/payments/use-multiple-currencies-with-stripe',
      external: true
    }
  });
};
const useInvoiceCurrencyValidator = (skip, onError) => {
  const [loading, setLoading] = useState(!skip);
  const [error, setError] = useState(false);
  const [currencies, setCurrencies] = useState([]);
  useEffect(() => {
    if (!skip) {
      http.get('payments/v1/limits/portal-currencies').then(portalCurrencies => {
        setCurrencies(portalCurrencies);
        setLoading(false);
      }).catch(currencyError => {
        setError(true);
        setLoading(false);
        if (onError) onError(currencyError);
      });
    }
  }, [skip, onError]);
  const currencyValidator = useCallback((_deprecatedProp, currencyToCheck) => {
    if (loading || error || skip) return null;
    if (currencyToCheck) {
      const isValidCurrency = !!currencies.filter(isProcessorSupportedCurrency).find(curr => curr.currencyCode === currencyToCheck);
      if (!isValidCurrency) {
        return getCurrencyErrorMessage();
      }
    } else if (!hasValidCurrencyInPortal(currencies)) {
      return getCurrencyErrorMessage(true);
    }
    return null;
  }, [loading, currencies, error, skip]);
  return {
    loading,
    error,
    currencyValidator
  };
};
export default useInvoiceCurrencyValidator;